import { SharedModule } from '../../../../../core/modules/shared.module';
import { FuseWidgetModule } from '../../../../../core/components/widget/widget.module';
import { RouterModule } from '@angular/router';
import { LightboxModule } from 'ngx-lightbox';
import { NgModule } from '@angular/core';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { CurriculumComponent } from './curriculum.component';
import { CurriculumService } from '../../../../services/curricula/curriculum.service';
import { AddEditCurriculumModule } from './add-edit-curriculum/add-edit-curriculum.module';

const routes = [
    {
        path: 'pages/management/curriculum',
        component: CurriculumComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_CURRICULUM',
                redirectTo: '/pages/errors/error-403'
            }
        }
    }
];

@NgModule({
    declarations: [
        CurriculumComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        FuseWidgetModule,
        LightboxModule,
        AddEditCurriculumModule
    ],
    exports: [
        CurriculumComponent
    ],
    entryComponents: [

    ],
    providers: [
        CurriculumService
    ]
})

export class CurriculumModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/curricula/curriculum.module.ts